Drupal.behaviors.tirillaTooltip = {
	attach: function (context, settings) {
		let btnTicket = document.querySelector('fieldset[id^=edit-digital-ticket] legend');
		let respFiscal = document.querySelector('.resp_fiscal legend');
		let regimFiscal = document.querySelector('.regim_contable legend')

		function tirillaTooltip(btn){

			if (btn != undefined) {
				btn.addEventListener('mouseenter', el => {
					let
						overlay = el.target;
					btn.parentElement.previousElementSibling.classList.add('open');
				});
	
				btn.addEventListener('mouseleave', el => {
					let
						overlay = el.target;
	
						btn.parentElement.previousElementSibling.classList.remove('open');
				});
	
				btn.addEventListener('touchstart', el => {
					let
						overlay = el.target;
	
						btn.parentElement.previousElementSibling.classList.add('open');
				});
	
				btn.addEventListener('touchend', el => {
					let
						overlay = el.target;
	
						btn.parentElement.previousElementSibling.classList.remove('open');
				});
			}
		}

		tirillaTooltip(btnTicket);
		// tirillaTooltip(respFiscal);
		// tirillaTooltip(regimFiscal);

	}
}

